<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="cs-sample-modal max-modal"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: '検索例の編集', en: 'Sample Search' }) }}
      </template>
      <div class="jps-modal-content">
        <ValidationForm
          :target="name"
          :rule="rule"
          @valid="(v) => nameValid = v"
        />

        <SearchBox :ss="ss" />
        <UiItemSearchResult v-if="ss.searched" :ss="ss" />
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()" :disabled="!valid">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { testCustomSearch } = useItem()

interface Props {
  editstate?: CsEditState,
  query?: SearchQuery
}
const props = withDefaults(defineProps<Props>(),{
})

const modal = ref<InstanceType<typeof BaseModal>>()
const sample: Ref<SearchQuery> = ref()
const ss: Ref<SearchStore<Item>> = ref()
const name: Ref<{ name: {} }> = ref()
const nameValid :Ref<boolean> = ref(false)
const openAwait = async (options?: Props) => {
  sample.value = {}
  name.value = { name: {} }
  nameValid.value = false

  let _editstate: CsEditState = getOptionsValue('editstate', props, options)
  let _cs = clone(_editstate.cs)
  _cs.constraints = []

  ss.value = useSearch<Item>(_cs, testCustomSearch(_cs), {
    configSyncRoute: false
  })
  ss.value.addAfterSearchListener((r) => {
    sample.value = clone(ss.value.state.currentQuery)
  })

  let _query: SearchQuery = null
  if (props.query) {
    _query = props.query
  } else if (options?.query) {
    _query = options.query
  }
  if (_query) {
    name.value.name = _query.name
    nextTick(() => {
      ss.value.restoreQuery(_query)
    })
  }
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

const valid = computed(() => {
  return nameValid.value && !isEmpty(sample.value)
})

const rule: ValidationRule = {
  fields: {
    name: {
      type: 'object',
      objRuleName: 'jps-lang_string',
      field: 'name',
      jaMandatory: true,
      label: {
        ja: '検索例の名称',
        en: 'Search example name',
      },
    },
  },
}

const confirm = () => {
  delete sample.value.from
  delete sample.value.size
  delete sample.value.sort
  sample.value.name = name.value.name
  modal.value.resolve(normalizeEmpty(sample.value))
}
</script>

<style lang="scss" scoped>
.cs-sample-modal {
  .jps-search-box {
    margin-top: 1.5rem;
  }
}
</style>
